export interface LegacySystemFeeHistoryRow {
  id: number
  office: string
  paidAt: string
  points: number
  product: string
  quantity: string
}

export const legacySystemFeeHistoryOffices = ['Mock 지점 01', 'Mock 지점 02']
export const legacySystemFeeHistoryRows: LegacySystemFeeHistoryRow[] = [
  { id: 1, office: 'Mock 지점 01', paidAt: '2026-08-20 10:00:00', points: 50000, product: '프로그램 사용권', quantity: '1 개월' },
  { id: 2, office: 'Mock 지점 02', paidAt: '2026-08-18 09:30:00', points: 20000, product: '스토리지', quantity: '100 GB' },
]
